import React, { useEffect, useState } from 'react';
import "../../Assets/Css/Leave.scss";
import CustomCalendar from '../../Components/CustomCalendar';
import Select from 'react-select';
import { customStyle } from '../../Components/Style';
import Table from '../../Components/Table';
import { useLocation, useNavigate } from 'react-router-dom';
import Calendaricon from "../../Assets/Images/Holiday/calendar"
import Listicon from "../../Assets/Images/Holiday/list"

const Status = [
     { value: "All", label: "All" },
     { value: "Earned", label: "Earned" },
     { value: "Casual", label: "Casual" },
     { value: "Unpaid", label: "Unpaid" },
];

const Employees = [
     { value: "All", label: "All" },
     { value: "Meet", label: "Meet" },
     { value: "Kuntesh", label: "Kuntesh" },
     { value: "Raj", label: "Raj" },
];

const Leaves = () => {
     const [leaveStatus, setLeaveStatus] = useState({});
     const [employees, setEmployees] = useState({ givenTo: Employees[0] });
     const [totalSelectedIds, setTotalSelectedIds] = useState([]);
     const [activeButton, setActiveButton] = useState("");

     const navigate = useNavigate()
     const location = useLocation();

     useEffect(() => {
          const path = location.pathname.slice(1);
          setActiveButton(path)
     }, []);

     const handleClick = (buttonId, route) => {
          setActiveButton(buttonId);
          navigate(route);
     };

     const header = [
          { field: "checkbox" },
          { field: "Employee" },
          { field: "Leave Date" },
          { field: "Duration" },
          { field: "Leave Status" },
          { field: "Leave Type" },
          { field: "Action" },
     ];

     const data = [{
          checkbox: {
               value: 1,
               type: "checkbox",
          },
          Employee: {
               value: "Harsh",
               value2: "Developer",
               src: "",
               type: "client"
          },
          "Leave Date": {
               value: "12-12-2024",
               type: "date"
          },
          Duration: {
               value: "Half Day",
               type: "text"
          },
          "Leave Status": {
               value: "Approved",
               type: "status"
          },
          "Leave Type": {
               value: "Casual",
               type: "leaveType"
          },
          Action: {
               value: "/leave/edit",
               value2: "/leave/view",
               value3: "Delete",
               value4: "/leave/approve",
               value5: "/leave/reject",
               type: "action",
          }
     }]

     const handleChange = (e) => {
          if (e[1] == "headerAll" && e[0] === true) {
               setTotalSelectedIds([...e[2]]);
          } else if (e[0] === true && e[1] !== "headerAll") {
               setTotalSelectedIds([...totalSelectedIds, e[1]]);
          } else if (e[1] == "headerAll" && e[0] === false) {
               setTotalSelectedIds([]);
          } else {
               let filterdId = totalSelectedIds.filter((item) => {
                    return item != e[1];
               });
               setTotalSelectedIds(filterdId);
          }
     };

     let footer = true;
     let count = 1;

     const handleNavigate = () => {
          navigate('/leave/add')
     }

     const handleCalendarView = () => {
          navigate('/leave/calendar')
     }

     return (
               <div className='leave-container'>
                    <div className='leave-header-part'>
                         <p className='leave-title'>Leave</p>
                    </div>

                    <div className='profile-container'>
                         <div className='row'>
                              <div class="leave-part common-card">
                                   <div className='profile-heading'>
                                        <span>Leave Quota</span>
                                   </div>
                                   <div class="leave-bar">
                                        <div class="casual">
                                             <div className='title'>Casual</div>
                                             <div style={{
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  flexDirection: 'row'
                                             }}>
                                                  <div>
                                                       <p>No. of</p>
                                                       <p>Leaves</p>
                                                       <span>23.5</span>
                                                  </div>
                                                  <div>
                                                       <p>Monthly</p>
                                                       <p>Limit</p>
                                                       <span>30</span>
                                                  </div>
                                                  <div>
                                                       <p>Total Leaves</p>
                                                       <p>Taken</p>
                                                       <span>18.5</span>
                                                  </div>
                                             </div>
                                        </div>
                                        <div class="earned">
                                             <div className='title'>Earned</div>
                                             <div style={{
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  flexDirection: 'row'
                                             }}>
                                                  <div>
                                                       <p>No. of</p>
                                                       <p>Leaves</p>
                                                       <span>23.5</span>
                                                  </div>
                                                  <div>
                                                       <p>Monthly</p>
                                                       <p>Limit</p>
                                                       <span>30</span>
                                                  </div>
                                                  <div>
                                                       <p>Total Leaves</p>
                                                       <p>Taken</p>
                                                       <span>18.5</span>
                                                  </div>
                                             </div>
                                        </div>
                                        <div class="unpaid">
                                             <div className='title'>Unpaid Leave</div>
                                             <div style={{
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  flexDirection: 'row'
                                             }}>
                                                  <div>
                                                       <p>No. of</p>
                                                       <p>Leaves</p>
                                                       <span>23.5</span>
                                                  </div>
                                                  <div>
                                                       <p>Monthly</p>
                                                       <p>Limit</p>
                                                       <span>30</span>
                                                  </div>
                                                  <div>
                                                       <p>Total Leaves</p>
                                                       <p>Taken</p>
                                                       <span>18.5</span>
                                                  </div>
                                             </div>
                                        </div>

                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className='leave-filters-part-container'>
                         <div className='input-fields'>
                              <div className="input-group">
                                   <CustomCalendar />
                              </div>

                              <div className="input-group">
                                   <Select
                                        // placeholder="Select"
                                        options={Employees}
                                        styles={{
                                             ...customStyle,
                                             menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 2,
                                             }),
                                        }}
                                        value={employees.givenTo}
                                        onChange={(val) => {
                                             setEmployees((preVal) => ({
                                                  ...preVal,
                                                  givenTo: val
                                             }));
                                        }}
                                        theme={(theme) => ({
                                             ...theme,
                                             colors: {
                                                  ...theme.colors,
                                                  primary25: "#5757fe",
                                                  primary: "#5757fe",
                                             },
                                        })}
                                   />
                              </div>

                              <div className="input-group">
                                   <Select
                                        placeholder="Status"
                                        options={Status}
                                        styles={{
                                             ...customStyle,
                                             menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 2,
                                             }),
                                        }}
                                        value={leaveStatus.givenTo}
                                        onChange={(val) => {
                                             setLeaveStatus((preVal) => ({
                                                  ...preVal,
                                                  givenTo: val
                                             }));
                                        }}
                                        theme={(theme) => ({
                                             ...theme,
                                             colors: {
                                                  ...theme.colors,
                                                  primary25: "#5757fe",
                                                  primary: "#5757fe",
                                             },
                                        })}
                                   />
                              </div>
                         </div>
                    </div>

                    <div className='action-part'>
                         <div className='edit-btn'>
                              <button className='custom-btn' onClick={handleNavigate}>Add Leave</button>
                              <button className='custom-btn'>Export</button>
                         </div>

                         <div className="navigation_btn">
                              <button
                                   className={`btn1 ${activeButton === "leave" ? "active" : ""}`}
                                   onClick={() => handleClick("leave", "/leave")}
                              >
                                   <Listicon color={activeButton === "leave" ? "white" : "black"} bgColor={activeButton === "leave" ? "black" : "white"} />
                              </button>
                              <button
                                   className={`btn1 ${activeButton === "calendar" ? "active" : ""}`}
                                   onClick={() => handleClick("calendar", "/leave/calendar")}
                              >
                                   <Calendaricon color={activeButton === "calendar" ? "white" : "black"} bgColor={activeButton === "calendar" ? "black" : "white"} />
                              </button>
                         </div>
                    </div>


                    <div className='table-part'>
                         <Table
                              header={header}
                              data={data}
                              footer={footer}
                              showIsDelete={true}
                              showIsApprove={true}
                              showIsReject={true}
                              showIsEdit={true}
                              count={count}
                              handleChange={handleChange}
                         />
                    </div>
               </div>
     );
}

export default Leaves;
